import {
  applicationOfferFormAddInfoConfig,
  applicationOfferFormMainInfoConfig,
} from '@acme/domains';
import type { FieldConfig, FormConfig, SelectOption } from '@acme/foundation';

export type FormAgentInfoFormData = {
  commissionAuthorizedOrganizationRUB?: number | string;
  commissionAgentRUB?: number | string;
  agentCryptoAddress?: string;
  agentWalletNetId?: number | string;
  cryptoCurrencyId?: number | string;
  cryptoAmount?: number | string;
  organizationName?: string;
  senderCountryId?: number | string;
  bankName?: string;
  files: File[];
};

type OptionsType = {
  nets: SelectOption[];
  cryptoCurrencies: SelectOption[];
  countries: SelectOption[];
};

const requiredAlways = {
  when: () => true,
  set: { required: true },
} as const;

const requiredValidationText = (v: unknown) =>
  typeof v === 'string' && !v.trim() ? 'Обязательное поле' : null;

const requiredValidationNumberOrSelect = (v: unknown) =>
  v === '' || v === undefined || v === null ? 'Обязательное поле' : null;

const requiredValidationFiles = (v: unknown) =>
  !Array.isArray(v) || v.length === 0 ? 'Обязательное поле' : null;

function withRequired<T>(
  cfg: FieldConfig<T>
): FieldConfig<FormAgentInfoFormData> {
  const base = { ...cfg, rules: [requiredAlways] };
  if (cfg.type === 'text') {
    return {
      ...base,
      validation: requiredValidationText,
    } as FieldConfig<FormAgentInfoFormData>;
  }
  if (cfg.type === 'number' || cfg.type === 'select') {
    return {
      ...base,
      validation: requiredValidationNumberOrSelect,
    } as FieldConfig<FormAgentInfoFormData>;
  }
  return base as FieldConfig<FormAgentInfoFormData>;
}

export const formAgentInfoFormConfig = (
  options: OptionsType
): FormConfig<FormAgentInfoFormData> => {
  const mainConfig = applicationOfferFormMainInfoConfig(true, {
    nets: options.nets,
    cryptoCurrencies: options.cryptoCurrencies,
  });
  const addConfig = applicationOfferFormAddInfoConfig(true, {
    countries: options.countries,
  });
  return {
    id: 'form-agent-info',
    includeUnchangedFields: true,
    controls: [
      ...mainConfig.controls.map((c) => withRequired(c)),
      ...addConfig.controls.map((c) => withRequired(c)),
      {
        id: 'files',
        label: 'Загрузка документов',
        type: 'fileUpload' as const,
        read: () => [],
        write: {
          path: 'files',
          transform: (v: unknown) =>
            Array.isArray(v) ? (v as { file: File }[]).map((u) => u.file) : [],
        },
        validation: requiredValidationFiles,
        rules: [requiredAlways],
        props: {
          label: 'Загрузка документов',
          accept: '.pdf',
          maxSize: 10,
          multiple: true,
          showInfoIcon: true,
        },
      },
    ],
  } as FormConfig<FormAgentInfoFormData>;
};

export const MAIN_SECTION_IDS = [
  'commissionAuthorizedOrganizationRUB',
  'commissionAgentRUB',
  'agentCryptoAddress',
  'agentWalletNetId',
  'cryptoCurrencyId',
  'cryptoAmount',
] as const;

export const ADD_SECTION_IDS = [
  'organizationName',
  'senderCountryId',
  'bankName',
] as const;
